import type { GetCompanyArtistsResponseType } from 'src/api/generated/touring/types';
import { mapCompanyArtistType } from './helpers/mapCompanyArtistType';
import type { GetCompanyArtistsType } from './types';

export const mapGetCompanyArtistsResponseType = (
  api: GetCompanyArtistsResponseType
): GetCompanyArtistsType => ({
  artists: api.data.map(mapCompanyArtistType),
});
